import { createGlobalStyle } from 'styled-components';
import img from './9s.jpg';

const InfoStyle = createGlobalStyle`
body {
  background: url('${img}') no-repeat center center fixed;
  background-size: cover;
  background-color: #f2f2f2;
  font-family: Arial, sans-serif;
  font-size: 16px;
  color: white;
  text-align: left;
  margin: 0;
  padding: 0;
  text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.3em black;
  min-height: 100vh;
  overflow-x: hidden;
}

.info-main {
  flex: 1;
  padding: 2rem 1rem 3rem;
  max-width: 100%;
  overflow-x: hidden;
}




label {
    display: block;
    margin: 20px 0;
    font-size: 20px;
    font-weight: bold;
    color: white;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
    text-align:center;
}

input[type="radio"] {
    margin: 0 5px 0 0;
}



p {
  font-family: 'SCE-PS3 Rodin LATIN', sans-serif;
    font-size: 18px;
    font-weight: bold;
    color: white;
    margin-top: 1rem;
    text-align: left;
    text-shadow: 2px 2px 2px black, 0 0 0.1em rgba(0,0, 0, 0.8), 0 0 0.3em rgba(0,0, 0, 0.9);
    background: linear-gradient(135deg, rgba(180, 157, 71, 0.7) 0%, rgba(212, 175, 55, 0.7) 100%);
    border-radius: 5px;
    border: 1px solid rgba(212, 175, 55, 0.5);
    box-shadow: 0 0 10px rgba(212, 175, 55, 0.3);
    padding: 1.5rem;
    position: relative;
    z-index: 1;
    width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    overflow: hidden;
}

p1 {
    font-family: 'SCE-PS3 Rodin LATIN', sans-serif;
    font-size: 28px;
    font-weight: bold;
    color: #d4af37;
    background: rgba(0, 0, 0, 0.8);
    margin-top: 0 !important;
    margin-bottom: 1.5rem !important;
    text-align: center;
    text-shadow: 0 0 10px rgba(212, 175, 55, 0.8);
    padding: 1rem 1.5rem;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    border: 2px solid rgba(212, 175, 55, 0.6);
    display: block;
    position: relative;
    z-index: 1;
}

p2 {
    font-family: 'SCE-PS3 Rodin LATIN', sans-serif;
    font-size: 35px;
    font-weight: bold;
    color: white;
    background-color:black;
    margin-top: 30px;
    text-align: center;
    border-radius:3px; 
    border-shadow: 2px 2px 4px rgba(1, 1, 1, 0.3); 
    animation: electricbox 1s infinite;
    display:inline-block;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
    padding: 20px 10px 10px 10px;
}

#message {
    overflow: hidden; /* Hide overflow text */
    display: inline-block; /* Ensure the cursor appears next to the text */
    
   
  }
  
  #message::after {
    content: "|"; /* Cursor symbol */
    display: inline-block; /* Display inline with the text */
    vertical-align: bottom; /* Align with the bottom of the text */
    
    animation: blink 1s infinite;  /* Alternate blink direction */
  }
  
  @keyframes blink {
    50% {
      opacity: 0; /* Make the cursor blink */
    }
    
    
  }
.reveal-button {
    
    background-color: black;
    border: none;
    color: white;
    padding: 12px 24px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
    }
/* Footer - Handled by EnhancedFooter component */
/* footer {
  margin-top: auto;
  height: 60px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 18px;
  padding-top: 20px;
  flex-shrink: 0;
} */

header {
  background-color: #333;
 padding: 20px;
  
  padding-bottom: 30px;
  margin: 0 auto;
      }
nav ul {
        margin: 0;
        padding: 0;
        list-style: none;
  }

nav ul li {
   display: inline-block;
   margin-right: 20px;
}

nav ul li:last-child {
margin-right: 0;
}

nav ul li a,nav ul li button {
 color: #fff;
text-decoration: none;
font-size: 20px;
font-weight: bold;
text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;

}

nav ul li a,nav ul li button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    
  }
  nav ul li a:hover,nav ul li button:hover {
 color: black;
      text-shadow: 1px 1px 2px white, 0 0 1em white, 0 0 0.2em white;
       animation: electric 0.8s infinite;
}

@keyframes electric {
0% {
text-shadow: 2px 2px 4px rgba(1, 1, 1, 0.3);
}
50% {
text-shadow: 2px 2px 8px white, 0 0 20px white;
}
100% {
text-shadow: 2px 2px 4px rgba(1, 1, 1, 0.3);
}
}
    @keyframes electricbox {
0% {
box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}
50% {
box-shadow: 2px 2px 8px white, 0 0 20px pink;
}
100% {
box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}
}

@keyframes fadeOut {
    from {
      opacity: 1; 
    }
    to {
      opacity: 0; 
    }
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0; /* Start with completely transparent */
    }
    to {
      opacity: 1; /* Fade in to full opacity */
    }
  }
   
  .welcome {
    text-align: center;
    justify-content: center;
    opacity: 1;
    animation: fadeOut 1s forwards 20s;
    position: flex;
  }
  
  .sections {
    text-align: center;
    display: flex;
    justify-content: center;
   position: flex;
    
  }

  .infoloader {
    width: 48px;
    height: 48px;
    display: inline-block;
    position: flex;
    border: 2px solid #FFF;
    box-sizing: border-box;
    animation: rotation 2s linear infinite;
  }
  .infoloader::after,
  .infoloader::before {
    content: '';  
    box-sizing: border-box;
    position: absolute;
    display: flex;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    border: 2px solid black;
    width: 38px;
    height: 38px;
    animation: rotationBack 1.5s linear infinite;
    transform-origin: center center;
  }
  .infoloader::before {
    width: 28px;
    height: 28px;
    display:flex;
    border-color: #FFF;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
  
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  } 
  @keyframes rotationBack {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }

  .section-list {
    justify-content: center;
    margin: 0 auto;
    display: flex;
    position: relative;
    width: 100%;
  }
  
  .section-list ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    position: relative;
  }
  
  .section-list li {
    position: relative;
  }
  
  .section-list li button {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.9) 0%, rgba(40, 40, 40, 0.9) 100%);
    color: white;
    border: 2px solid rgba(212, 175, 55, 0.8);
    padding: 12px 24px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
    opacity: 0;
    animation: fadeIn 1s forwards, electricbox 1s forwards;
    position: relative;
    transition: all 0.3s ease;
    box-shadow: 0 0 10px rgba(212, 175, 55, 0.3);
  }
  
  /* Apply animation delay to each button - faster appearance */
  .section-list li:nth-child(1) button { animation-delay: 4s; }
  .section-list li:nth-child(2) button { animation-delay: 4.5s; }
  .section-list li:nth-child(3) button { animation-delay: 5s; }
  .section-list li:nth-child(4) button { animation-delay: 5.5s; }
  .section-list li:nth-child(5) button { animation-delay: 6s; }
  
  @keyframes fadeIn {
    0% {
      opacity: 0; /* Start with opacity 0 */
    }
    100% {
      opacity: 1; /* Fade in to full opacity */
    }
  }
  
  .section-list li button:hover {
    background: linear-gradient(135deg, rgba(40, 40, 40, 0.9) 0%, rgba(80, 80, 80, 0.9) 100%);
    border-color: rgba(212, 175, 55, 1);
    box-shadow: 0 0 20px rgba(212, 175, 55, 0.6);
    transform: translateY(-2px);
  }
  
  .section-list li button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.3);

    
  }
  
  @keyframes electricbox {
    0% {
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
      box-shadow: 2px 2px 8px white, 0 0 20px pink;
    }
    100% {
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
  }
  
  .infobox {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(40, 30, 20, 0.5) 100%);
    font-family: 'SCE-PS3 Rodin LATIN', sans-serif;
    text-shadow: 1px 1px 2px black, 0 0 3em black, 0 0 0.3em black;
    margin: 2rem auto;
    padding: 2rem;
    border-radius: 10px;
    border: 2px solid rgba(212, 175, 55, 0.8);
    box-shadow: 0 0 20px rgba(212, 175, 55, 0.3), inset 0 0 20px rgba(212, 175, 55, 0.1);
    animation: fadeIn 1s forwards, shadow-move-gold 4s infinite alternate;
    width: calc(100% - 2rem);
    max-width: 900px;
    box-sizing: border-box;
    backdrop-filter: blur(5px);
    position: relative;
    overflow: hidden;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .infobox::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2px,
        rgba(212, 175, 55, 0.03) 2px,
        rgba(212, 175, 55, 0.03) 4px
    );
    animation: scan 10s linear infinite;
    pointer-events: none;
  }

  @keyframes scan {
    0% { transform: translateY(0); }
    100% { transform: translateY(50%); }
  }

  @keyframes shadow-move-gold {
    0% {
        box-shadow: 0 0 0 rgba(212, 175, 55, 0.4), 0 0 20px rgba(212, 175, 55, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(212, 175, 55, 0.4), 0 0 20px rgba(212, 175, 55, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(212, 175, 55, 0.4), 0 0 20px rgba(212, 175, 55, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(212, 175, 55, 0.4), 0 0 20px rgba(212, 175, 55, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(212, 175, 55, 0.4), 0 0 20px rgba(212, 175, 55, 0.4);
    }
  }
  
  .type-button {
    
    justify-content: center;
    margin-top: 20px;
    display: inline-block;
  }
  
  .type-button {
    width: 150px;
    height: 150px;
    font-family: 'SCE-PS3 Rodin LATIN', sans-serif;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.9) 0%, rgba(40, 40, 40, 0.9) 100%);
    color: white;
    border: 2px solid rgba(212, 175, 55, 0.8);
    font-size: 16px;
    font-weight: bold;
    margin: 1rem;
    border-radius: 50%;
    opacity: 0;
    animation: fadeIn 1s forwards, electricbox 1s forwards;
    position: relative;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 0 10px rgba(212, 175, 55, 0.3);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  
  .type-button:hover {
    background: linear-gradient(135deg, rgba(40, 40, 40, 0.9) 0%, rgba(80, 80, 80, 0.9) 100%);
    border-color: rgba(212, 175, 55, 1);
    box-shadow: 0 0 20px rgba(212, 175, 55, 0.6);
    transform: scale(1.05);
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .info-main {
      padding: 1.5rem 0.75rem 3rem !important;
      min-height: calc(100vh - 140px) !important;
      max-width: 100vw !important;
      overflow-x: hidden !important;
    }

    p {
      font-size: 16px;
      padding: 1.25rem;
      width: 100%;
      box-sizing: border-box;
      font-size: 15px !important;
    }

    p1 {
      font-size: 24px !important;
      padding: 0.875rem 1.25rem !important;
      box-sizing: border-box !important;
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 1.25rem !important;
    }

    p2 {
      font-size: 28px;
      padding: 15px 8px 8px 8px;
    }

    .infobox {
      padding: 1.5rem;
      margin: 1.5rem 0.5rem;
      width: calc(100% - 1rem);
      max-width: calc(100vw - 2.5rem);
      box-sizing: border-box;
    }

    .section-list ul {
      gap: 0.75rem;
    }

    .section-list li button {
      padding: 10px 20px;
      font-size: 14px;
    }

    .type-button {
      width: 120px;
      height: 120px;
      font-size: 14px;
      margin: 0.75rem;
    }

    footer {
      font-size: 14px !important;
      padding: 15px 10px 0 !important;
      height: auto !important;
      min-height: 50px !important;
    }
  }

  @media (max-width: 480px) {
    .info-main {
      padding: 1rem 0.5rem 2.5rem !important;
      min-height: calc(100vh - 120px) !important;
      max-width: 100vw !important;
      overflow-x: hidden !important;
    }

    p {
      font-size: 13px !important;
      padding: 1rem;
      width: 100%;
      box-sizing: border-box;
    }

    p1 {
      font-size: 20px !important;
      padding: 0.75rem 1rem !important;
      box-sizing: border-box !important;
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 1rem !important;
    }

    p2 {
      font-size: 24px;
      padding: 12px 6px 6px 6px;
    }

    .infobox {
      padding: 1.25rem;
      margin: 1rem 0.25rem;
      width: calc(100% - 0.5rem);
      max-width: calc(100vw - 1.5rem);
      box-sizing: border-box;
    }

    .section-list ul {
      gap: 0.5rem;
      flex-direction: column;
      align-items: center;
    }

    .section-list li button {
      padding: 8px 16px;
      font-size: 13px;
      width: 100%;
      max-width: 250px;
    }

    .type-button {
      width: 100px;
      height: 100px;
      font-size: 13px;
      margin: 0.5rem;
    }

    .infoloader {
      width: 36px;
      height: 36px;
    }

    .infoloader::after,
    .infoloader::before {
      width: 28px;
      height: 28px;
    }

    .infoloader::before {
      width: 20px;
      height: 20px;
    }

    footer {
      font-size: 13px !important;
      padding: 12px 8px 0 !important;
    }
  }
  
`;
export default InfoStyle;
